import { observer } from 'mobx-react-lite';
import { Divider, HStack, VStack } from '@cad-arc';
import { FrEntityLocationSelectValueDisplay } from '../../../../fr-entity-panels/components/fr-entity-location-select-value-display';
import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { FrBoloDetailsTabInformationSection } from './fr-bolo-details-information-section';
import { FrBoloDetailsTabRecipientsSection } from './fr-bolo-details-recipients-section';
import { FrBoloDetailsTimestampsSection } from './fr-bolo-details-timestamps-section';
import { FrBoloDetailsEntities } from './fr-bolo-details-entities';

export const BOLO_SUMMARY_SECTION_WIDTH = '440px';

const BoloDetailsDivider = () => <Divider style={{ marginTop: '16px', marginBottom: '12px' }} />;

export const FrBoloDetailsTab = observer(() => {
    const metadata = useBoloPanelMetadata();

    if (!metadata) {
        return null;
    }

    return (
        <VStack>
            <HStack w="100%" h="100%" alignItems="flex-start">
                <VStack
                    w={`calc(100% - ${BOLO_SUMMARY_SECTION_WIDTH})`}
                    h="100%"
                    p={6}
                    gap={2}
                    alignItems="flex-start"
                    borderRightWidth="1px"
                    borderRightColor="border.default"
                >
                    <FrEntityLocationSelectValueDisplay
                        entityType="BOLO"
                        entityId={metadata.boloId}
                    />
                    <BoloDetailsDivider />
                    <FrBoloDetailsTabInformationSection />
                    <BoloDetailsDivider />
                    <FrBoloDetailsTabRecipientsSection />
                    <BoloDetailsDivider />
                    <FrBoloDetailsTimestampsSection />
                </VStack>
                <VStack h="100%" w={BOLO_SUMMARY_SECTION_WIDTH}>
                    <FrBoloDetailsEntities />
                </VStack>
            </HStack>
        </VStack>
    );
});
